/**
 * @file: useQuotationNavigation.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import type { QuotationNavParams } from '@euler/app/flows/task/pages/quotation/QuotationFlow';
import { useNavigation } from '@react-navigation/native';
import { StackNavigationProp } from '@react-navigation/stack';

export const useQuotationNavigation = () => {
  return useNavigation<StackNavigationProp<QuotationNavParams>>();
};
